<app-grid>
  <app-cell desktop="0:3"
    laptop="0:3"
    tablet="0:12"
    mobile="0:12"
    >
    <h3 class="title">
      {{ pageLinks.title }}
    </h3>
  </app-cell>

  <app-cell desktop="3:12"
    laptop="3:12"
    tablet="0:12"
    mobile="0:12"
    >
    @if (localization.currentLocale$ | async; as locale) {
      <div class="card-container"
        >
        <div class="grid">
          @for (card of pageLinks.pages; track card) {
            @if (card.localizations | ppLocale: locale; as localized) {
              <div class="card"
                (click)="routeToPage(locale, localized.slug)"
                >
                <div class="icon-bubble">
                  @if (card.icon) {
                    <span [appIconEnum]="card.icon" class="icon"></span>
                  }
                  @if (!card.icon) {
                    <span appIcon="dealer-shop" class="icon"></span>
                  }
                </div>
                <div class="subject">
                  <h3 class="subheading">
                    {{localized.title}}
                  </h3>
                  <span appIcon="arrow-fat-right"
                    class="arrow"
                  ></span>
                </div>
              </div>
            }
          }
        </div>
      </div>
    }
  </app-cell>
</app-grid>